module.exports = __webpack_public_path__ + "img/success.58ce41c3.webp";